import React from 'react';

import { DefaultFilledButton } from '@magoosh/lib/button';
import { SimpleBarChart } from '@magoosh/lib/charts';
import { SquareIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';

import ContextualLink from '@test_prep/app/components/contextual_link';

import { FlashcardDeckSet } from '../../types';

import colors from '@magoosh/lib/styles/colors.module.scss';

export default (props: FlashcardDeckSet) => {
  // There is similar code in the analytics subject header component. Would be nice to extract into
  // something resuable.
  const iconForSection = () => {
    const colorPalette = { dark: colors.blue, light: colors.blueLight };

    if (props.name.indexOf('Math') !== -1) {
      return (
        <SquareIcon
          colorPalette={colorPalette}
          iconType="math_operations"
          size={48}
        />
      );
    } else if (props.name.indexOf('Vocabulary') !== -1) {
      return (
        <SquareIcon
          colorPalette={colorPalette}
          iconType="notebook"
          size={48}
        />
      );
    } else {
      return (
        <SquareIcon
          colorPalette={colorPalette}
          iconContents={props.name[0]}
          iconType="letter"
          size={48} />
      );
    }
  };

  return (
    <div className="d-flex flex-column gap-m">
      <div className="align-items-center d-flex gap-s">
        {iconForSection()}
        <h3 className="u-margin-A-n">{props.name}</h3>
      </div>

      <div className="d-flex flex-column gap-s">
        <div className="align-items-lg-center d-flex flex-1 flex-column flex-md-row gap-xs gap-md-l">
          <div style={{ minWidth: 150 }}>
            {props.name.indexOf('Vocabulary') !== -1 ? 'Words' : 'Cards'} Attempted
          </div>

          <div className="flex-1">
            <SimpleBarChart
              colorPalette={{ dark: colors.dataDarkBlue, light: colors.dataMutedBlue }}
              data={[{
                data: [
                  { color: colors.dataDarkBlue, label: 'Attempted', value: Math.ceil((props.cards.attempted / props.cards.total) * 100) },
                  { color: colors.dataMutedBlue, label: 'Not Attempted', value: 100 - Math.ceil((props.cards.attempted / props.cards.total) * 100) }
                ]
              }]}
              hideLabel
              hideLegend
              noActivityLabel="No activity"
            />
          </div>
        </div>

        <div className="align-items-lg-center d-flex flex-1 flex-column flex-md-row gap-xs gap-md-l">
          <div style={{ minWidth: 150 }}>
            {props.name.indexOf('Vocabulary') !== -1 ? 'Words' : 'Cards'} Mastered
          </div>

          <div className="flex-1">
            <SimpleBarChart
              colorPalette={{ dark: colors.dataDarkBlue, light: colors.dataMutedBlue }}
              data={[{
                data: [
                  { color: colors.dataDarkBlue, label: 'Attempted', value: Math.ceil((props.cards.mastered / props.cards.total) * 100) },
                  { color: colors.dataMutedBlue, label: 'Not Attempted', value: 100 - Math.ceil((props.cards.mastered / props.cards.total) * 100) }
                ]
              }]}
              hideLabel
              hideLegend
              noActivityLabel="No activity"
            />
          </div>
        </div>
      </div>

      <hr className="u-margin-A-n" />

      <div className="d-flex gap-s">
        <ContextualLink href={paths.flashcardsDeck(props.currentDeck.slug, props.slug)}>
          <DefaultFilledButton size="sm">
            {props.currentDeck.started ? 'Resume' : 'Start'} {props.currentDeck.name}
          </DefaultFilledButton>
        </ContextualLink>

        <ContextualLink href={paths.flashcards(props.slug)}>
          <DefaultFilledButton size="sm">
            See All Decks
          </DefaultFilledButton>
        </ContextualLink>
      </div>
    </div>
  );
};
